module.exports = __webpack_public_path__ + "img/academy_strengths.d9a3c57e.png";